import React, { useState, useEffect } from "react";

import "./style.css";
import PageEmail from "../../components/PageEmail";
import PageTutorial from "../../components/PageTutorial";
import PageTest from "../../components/PageTest";
import Footer from "../../components/Footer";

export const TestSteps = {
  Tutorial: 0,
  Test: 1,
  Email: 2,
};

const Home = () => {
  const [clearGoddessList, setClearGoddessList] = useState({});
  const [currentTestStep, setCurrentTestStep] = useState(TestSteps.Test);
  const [questions, setQuestions] = useState([]);
  const [patterns, setPatterns] = useState([]);

  useEffect(() => {
    import("../../data/questions.json").then((data) => {
      setQuestions(data.default);
    });
    import("../../data/goddess.json").then((data) => {
      setPatterns(data.default);
    });
  }, []);

  return (
    <main>
      {currentTestStep === TestSteps.Tutorial ? (
        <section>
          <PageTutorial
            handleStartTest={() => {
              setCurrentTestStep(TestSteps.Test);
              window.scrollTo(0, 0);
            }}
          ></PageTutorial>
        </section>
      ) : currentTestStep === TestSteps.Test ? (
        <PageTest
          questions={questions}
          patterns={patterns}
          handleCurrentStep={setCurrentTestStep}
          handleClearGoddessList={setClearGoddessList}
        />
      ) : (
        <PageEmail content={clearGoddessList}></PageEmail>
      )}
      <Footer />
    </main>
  );
};

export default Home;
